import { useState } from 'react';
import cards from '~/assets/icons/cards_2.svg';
import { TextInput } from '~/components/ui/TextInput';
import { formatCardNumber } from '~/utils/cardNumber';
import {
	StyledCardOwner,
	StyledCardOwnerError,
	StyledContainer,
} from './CardInput.styled';

const CardInput = ({
	value,
	onChange,
	owner,
	error,
	...props
}: {
	value: string;
	onChange: (value: string) => void;
	owner: string | null;
	error: boolean;
} & Omit<React.HTMLAttributes<HTMLInputElement>, 'onChange'>) => {
	const [inputValue, setInputValue] = useState<string>(value);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length > 16) {
			return;
		}

		if (inputValue.length === 0) {
			setInputValue('');
		}

		setInputValue(inputValue);
		onChange(inputValue);
	};

	return (
		<StyledContainer>
			<TextInput
				height={60}
				fontSize={16}
				active={inputValue.length > 0}
				style={{ paddingLeft: 20, paddingRight: 60 }}
				placeholder={'Введите номер карты'}
				{...props}
				value={formatCardNumber(inputValue)}
				onChange={handleChange}
				error={error}
			/>
			<img src={cards} />
			{owner && (
				<StyledCardOwner>
					<span>Владелец:</span> {owner}
				</StyledCardOwner>
			)}
			{error && <StyledCardOwnerError>Владелец не найден</StyledCardOwnerError>}
		</StyledContainer>
	);
};

export { CardInput };
